import gql from "graphql-tag";

export const GET_NOTIFICATION = gql`
  subscription notification_logs($user_id: uuid, $admin_id: uuid) {
    notification_logs(
      where: {
        user_id: { _eq: $user_id }
        _or: { admin_id: { _eq: $admin_id } }
      }
      order_by: { created_at: desc }
    ) {
      id
      notification
      sub_category
      seen_at
      created_at
      updated_at
      notification_icon {
        icon_url
        icon_path
      }
    }
  }
`;

export const GET_NOTIFICATION_COUNT = gql`
  subscription notification_logs {
    unread_notifications_count: notification_logs_aggregate(
      where: { seen_at: { _is_null: true } }
    ) {
      aggregate {
        count
      }
    }
  }
`;
